const fileUploadProgressTemplate = '<div class="progress-group">' +
	'  <div class="progress-group-header">' +
	'    <div class="progress-bar-caption"></div>' +
	'    <div class="progress-bar-progress ms-auto font-weight-bold">43%</div>' +
	'  </div>' +
	'  <div class="progress-group-bars">' +
	'    <div class="progress progress-thin">' +
	'      <div class="progress-bar-bar progress-bar bg-warning" role="progressbar" style="width: 0" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>' +
	'    </div>' +
	'  </div>' +
	'</div>';

function createFileupload($upload, $listFiles, actionUrl, actionUrlParameters, workingTemplate, onSuccess, onFail, onBeforeAdd) {

	$upload.fileupload({
		url: rootPath + actionUrl + "_upload?" + $.param(actionUrlParameters),
		dropZone: $upload.find('#drop'),
		add: function (e, data) {

			data.contexts = [];

			if (util.isFunction(onBeforeAdd)) {
				onBeforeAdd.call($upload, data);
			}

			if (data.files[0].size > 52428800) {
				alert("Datei " + data.files[0].name + " kann nicht hochgeladen werden. Die Dateigröße darf maximal 50 MB betragen.");
				return;
			}

			const $progressBar = $(fileUploadProgressTemplate);
			$progressBar.find('.progress-bar-caption').text(data.files[0].name);

			const $template = $(workingTemplate);
			//$template.find('.icon').html('<input type="text" value="0" data-width="16" data-height="16" data-fgColor="#0788a5" data-readOnly="1" data-bgColor="#3e4043" />');
			$template.find('.file-upload').addClass('working');
			$template.find('.file-filename').append($progressBar);
			$template.find('.file-filesize').text(util.formatFileSize(data.files[0].size));
			/*$template.find('.file-upload-abort').html('<a href="#" class="cmd-delete btn-icon text-danger"><i class="fa fa-trash"></i></a>');*/

			data.context = $template.appendTo($listFiles);
			data.contexts.push(data.context);

			//$template.find('input').knob();
			$template.find('.cmd-delete').click(function () {
				if ($template.hasClass('working')) {
					jqXHR.abort();
				}
				$template.fadeOut(function () {
					$template.remove();
				});

			});
			var jqXHR = data.submit();
		},
		progress: function (e, data) {
			const progress = parseInt(data.loaded / data.total * 100, 10);
			data.contexts.forEach(context => {
				context.find('.progress-bar-progress').text(progress + '%');
				context.find('.progress-bar-bar')
					.attr("style", 'width:' + progress + '%;')
					.attr("aria-valuenow", progress);
				//context.find('input').val(progress).change();
				if (progress === 100) {
					context.removeClass('working');
				}
			});
		},
		done: function (e, data) {
			const res = data.result;
			//validationaware.updateUiErrors(res);
			if (res.success) {
				if(util.isFunction(onSuccess)) {
					onSuccess.call($upload, data);
				} else {
					const $tpl = $(workingTemplate);
					$tpl.attr('data-fileid', res.id);
					$tpl.attr('data-fileuuid', res.uuid);
					$tpl.find('.file-link').html(res.link);
					$tpl.find('.file-filename').text(res.filename);
					$tpl.find('.file-filesize').text(res.size);
					$tpl.find('.file-created').html(res.created);
					data.context.replaceWith($tpl);
				}
			} else {
				if (util.isFunction(onFail)) {
					onFail.call($upload, data);
				} else {
					data.contexts.forEach( context => {
						context.addClass('table-danger');
					});
				}
			}
		},
		fail:function(e, data){
			if(util.isFunction(onFail)) {
				onFail.call($upload, data);
			} else {
				const res = data.result;
				validationaware.updateUiErrors(res);
				data.contexts.forEach( context => {
					context.addClass('table-danger');
				});
			}
		}

	});

	$upload.find('#btnAddFromHarddisk').click(function(event){
		event.preventDefault();
		$(this).parent().find('input').click();
	});

	$(document).on('drop dragover', function (e) {
		e.preventDefault();
	});

	$listFiles.on('click', '.cmd-delete', function(event) {
		event.preventDefault();
		var section = $(this).closest('.file');
		var fileId = section.attr('data-fileid');

		loadlink($(this), actionUrl + "_delete", $.extend(actionUrlParameters,{'file.id': fileId}), function(data) {
			if(data.success) {
				section.remove();
			}
		});

	});

	$listFiles.on('click', '#btnFilenameOK', function(event){
		event.preventDefault();
		var section = $(this).closest('tr');
		var fileId = section.attr('data-fileid');
		var filename = $('#filename').val();

		loadlink($(this), actionUrl + "_changefilename", $.extend(actionUrlParameters, {'file.id': fileId, 'file.filename': filename}), function(data) {
			if(data.success) {
				section.find('.file-filename').text(data.filename);
				$('#btnFilenameOK').remove();
				section.find('.cmd-edit').show();
			}
		});
	});

	$listFiles.on('blur', '#filename', function(event) {

		if($(event.relatedTarget).attr('id') === 'btnFilenameOK') {
			return;
		}

		var section = $(this).closest('tr');
		section.find('.file-filename').text(origFilename);
		$('#btnFilenameOK').remove();
		section.find('.cmd-edit').show();
	});

	$listFiles.on('keydown', '#filename', function(event) {
		if(event.keyCode === 13) {
			event.preventDefault();
			event.stopPropagation();
			$('#btnFilenameOK').trigger('click');
		}
	});

	let origFilename = '';

	$listFiles.on('click', '.cmd-edit', function(event) {

		const section = $(this).closest('tr');
		if(section.find('#filename').length > 0) {
			return;
		}

		event.preventDefault();
		section.find('.cmd-edit').hide();
		origFilename = section.find('.file-filename').text();
		section.find('.file-filename').html(
			$('<input type="text" class="form-control" id="filename" value="">')
				.val(origFilename)
		);
		section.find('.file-filename-controls').append(
			'<a href="#" id="btnFilenameOK"><i class="fa fa-check"></i></a>'
		);
		$('#filename').focus();
	});

}

function initSingleFileupload() {

	$('.single-file-upload').each( function() {
		const $elemSingleFileUpload = $(this);
		const $elemFileUpload = $elemSingleFileUpload.find('.single-file-upload-file');
		const uploadUrl = util.getUrl($elemSingleFileUpload.data('action') + "upload", {
			'parent': $elemSingleFileUpload.data('parent'),
			'field': $elemSingleFileUpload.data('field')
		});
		const deleteUrl = util.getUrl($elemSingleFileUpload.data('action') + "delete", {
			'parent': $elemSingleFileUpload.data('parent'),
			'field': $elemSingleFileUpload.data('field')
		});

		$elemSingleFileUpload.find('.btn-delete').loadlink( deleteUrl, {}, function(data) {
			$elemSingleFileUpload.find('.single-file-upload-details').html('');
			$(this).hide();
		});

		$elemSingleFileUpload.find('.btn-upload').click(function(event){
			event.preventDefault();
			$(this)
				.closest('.single-file-upload')
				.find('.single-file-upload-file')
				.click();
		});

		$elemFileUpload.fileupload({
			url: uploadUrl,
			dataType: 'json',
			add: function (e, data) {

				if (data.files[0].size > 52428800) {
					alert("Datei " + data.files[0].name + " kann nicht hochgeladen werden. Die Dateigröße darf maximal 50 MB betragen.");
					return;
				}

				var tpl = $('<div class="single-file-upload-details-working">' +
					'<div class="single-file-upload-details-filename">' +
					'<input type="text" value="0" data-width="16" data-height="16" data-fgColor="#0788a5" data-readOnly="1" data-bgColor="#3e4043" /> <span class="filename"></span>' +
					'</div>' +
					'<div class="single-file-upload-details-filesize"></div>' +
					'</div>'
				);

				tpl.find('.filename').text(data.files[0].name);
				tpl.find('.single-file-upload-details-filesize').text(util.formatFileSize(data.files[0].size));
				tpl.find('input').knob();

				tpl.appendTo($elemSingleFileUpload.find('.controls'));
				data.context = $elemSingleFileUpload;
				data.submit();
			},
			progress: function (e, data) {
				var progress = parseInt(data.loaded / data.total * 100, 10);
				data.context.find('.single-file-upload-details-working input').val(progress).change();
				if (progress === 100) {
					data.context.removeClass('working');
				}
			},
			done: function (e, data) {
				validationaware.updateUiErrors(data);
				var res = data.result;
				data.context
					.find('.single-file-upload-details')
					.replaceWith(res.html);
				data.context.find('.single-file-upload-details-working').remove();
				data.context.find('.btn-delete').show();
			},
			fail: function (e, data) {
				validationaware.updateUiErrors(data);
				data.context.find('.single-file-upload-details-working').remove();
			}

		});

	})

}
